<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.general_id_information') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.businesses_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            multiple
            collapse-tags
            @change="
              selectAllFromSelect('model.businesses_id', businesses);
              getZones();
            "
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <label>{{ $t('common_words.date') }} *</label>
        <el-date-picker
          v-if="renderComponent"
          class="required-date"
          v-model="model.date"
          type="date"
          :placeholder="$t('common_words.date_pick')"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('samples.ground_select_element') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select nutrient-rels shadow-sm"
            size="large"
            style="width: 60%"
            v-model="model.ground_nutrient_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in ground_nutrients"
              class="select-primary"
              :value="option.id"
              :label="option.symbol"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group has-label">
          <label class="text-transform-none width-label"
            >{{ $t('common_words.crop_selection') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select crop-rels shadow-sm"
            size="large"
            v-model="model.crop_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            @change="getCropVarieties"
          >
            <el-option
              v-for="option in crops"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.zone_supply_select') }}*</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select zone-rels shadow-sm"
            size="large"
            v-model="model.zone_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            @change="getSubzones"
          >
            <el-option
              class="select-primary"
              :value="0"
              label="TODAS"
            ></el-option>
            <el-option
              v-for="option in zones"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group has-label">
          <label class="text-transform-none width-label"
            >{{ $t('common_words.geographical_zone_select') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select subzone-rels shadow-sm"
            size="large"
            v-model="model.subzone_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              class="select-primary"
              :value="0"
              :label="$t('common_words.mayus_all')"
            ></el-option>
            <el-option
              v-for="option in subzones"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="form-group has-label">
          <label class="text-transform-none width-label"
            >{{ $t('common_words.variety_select') }}*</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select cropvariety-rels shadow-sm"
            size="large"
            v-model="model.crop_variety_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              class="select-primary"
              :value="0"
              :label="$t('common_words.mayus_all')"
            ></el-option>
            <el-option
              v-for="option in crop_varieties"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row" v-show="errorAlert">
      <div class="col-lg-12">
        <br />
        <el-alert
          ref="error_alert"
          :title="$t('common_words.errors')"
          type="error"
          >{{ error }}</el-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        businesses_id: null,
        date: null,
        ground_nutrient_id: null,
        crop_id: null,
        zone_id: null,
        subzone_id: null,
        crop_variety_id: null,
      },
      businesses: null,
      ground_nutrients: [],
      crops: [],
      zones: [],
      subzones: [],
      crop_varieties: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.$emit('fillrangeGroundForm', 'firstStep', {
            names_business: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.businesses_id.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (this.model.date == null) {
            return this.validationInputsRequired('date');
          } else if (this.model.ground_nutrient_id == null) {
            for (let index of document.getElementsByClassName(
              'nutrient-rels'
            )) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (this.model.crop_id == null) {
            for (let index of document.getElementsByClassName('crop-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (this.model.zone_id == null) {
            for (let index of document.getElementsByClassName('zone-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (this.model.subzone_id == null) {
            for (let index of document.getElementsByClassName('subzone-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else if (this.model.crop_variety_id == null) {
            for (let index of document.getElementsByClassName(
              'cropvariety-rels'
            )) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              this.removeHasError(sel);
            }
          } else {
            return true;
          }
        });
    },

    getZones() {
      if (this.model.businesses_id.length > 0) {
        this.showHideLoading(true);
        let datarequest = {
          route: 'zones/indexbussiness',
          businesses_id: this.model.businesses_id,
        };
        Axios.saveMaster(datarequest)
          .then((response) => {
            this.zones = response.data.data;
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.zones = [];
      }
    },

    getCropVarieties() {
      if (this.model.crop_id != null && this.model.crop_id != '') {
        this.showHideLoading(true);
        Axios.getMasters('cropvarieties/' + this.model.crop_id)
          .then((response) => {
            this.crop_varieties = response.data.data;
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.crop_varieties = [];
      }
    },

    getSubzones() {
      if (this.model.zone_id != null) {
        this.showHideLoading(true);
        Axios.getMasters('subzones/indexzone/' + this.model.zone_id)
          .then((response) => {
            this.subzones = response.data.data;
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.subzones = [];
      }
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('businesses/only')
        .then((response1) => {
          Axios.getMasters('grounds/nutrients/index')
            .then((response2) => {
              Axios.getMasters('farms/crops')
                .then((response3) => {
                  this.businesses = this.concatAll(response1.data.data);
                  this.ground_nutrients = response2.data.data;
                  this.crops = response3.data.data;
                })
                .catch((error) => this.showMessageErrors(error));
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.showHideLoading(true);

    let editForm = {};

    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.id = editForm.id;
      this.model.businesses_id = editForm.businesses_id;
      this.model.date = editForm.date;
      this.model.ground_nutrient_id = editForm.ground_nutrient_id;
      this.model.crop_id = editForm.crop_id;
      this.getZones();
      this.model.zone_id = editForm.zone_id;
      this.getSubzones();
      this.model.subzone_id = editForm.subzone_id;
      this.getCropVarieties();
      this.model.crop_variety_id = editForm.crop_variety_id;
    }
  },
};
</script>
